import * as ko from 'knockout';

export class MarketingPreferences {
    Email: KnockoutObservable<boolean>;

    constructor() {
        this.Email = ko.observable(false);
    }
}